import { ApiBase } from '@orca/api-base';
import { useQuery } from '@tanstack/react-query';

import { USER_SETTINGS_QUERY_KEY } from '~/queries/keys';

export const useUserSettings = () => {
  return useQuery(
    [USER_SETTINGS_QUERY_KEY],
    () => {
      return ApiBase.users.settings();
    },
    {
      refetchOnWindowFocus: false,
      retry: 2,
      staleTime: 5000,
      refetchOnMount: false,
      refetchOnReconnect: false,
    }
  );
};
